const base = {
  default: {
    ['@media (max-width: 1000px)']: {
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: 'coolGrey.10',
      'button, a': {
        padding: '0.5rem'
      }
    }
  }
};

const item = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type ItemVariantsType = 'default';
export const itemVariants = Object.keys(base) as ItemVariantsType[];

export default item;
